import { Status } from '@webapp/ui';

export enum STATUS_POLICY {
	ACTIVE = 'ACTIVE',
	EMISSION = 'EMISSION',
	INACTIVE = 'INACTIVE',
	EXPIRED = 'EXPIRED',
	CANCELLED = 'CANCELLED',
}

export function buildStatus(status: string | null) {
	if (!status) {
		return {
			badgeStatus: Status.Info,
			badgeText: 'Sin estado',
		};
	}

	switch (status) {
		case STATUS_POLICY.ACTIVE:
			return {
				badgeStatus: Status.Success,
				badgeText: 'Activa',
			};
		case STATUS_POLICY.EXPIRED:
			return {
				badgeStatus: Status.Warning,
				badgeText: 'Vencida',
			};
		case STATUS_POLICY.EMISSION:
			return {
				badgeStatus: Status.Warning,
				badgeText: 'Contratada',
			};
		case STATUS_POLICY.CANCELLED:
			return {
				badgeStatus: Status.Error,
				badgeText: 'Anulada',
			};
		default:
			return {
				badgeStatus: Status.Info,
				badgeText: 'Inactiva',
			};
	}
}
